
import { lazy } from 'react';
import Login from '../pages/auth/login';
import { ProtectedRoute } from '../components/auth/ProtectedRoute';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AdminDashboard = lazy(() => import('../pages/admin/page'));
const RegionalCoordinator = lazy(() => import('../pages/regional/page'));
const PrefectoralCoordinator = lazy(() => import('../pages/prefectoral/page'));
const SousPrefectoralCoordinator = lazy(() => import('../pages/sous-prefectoral/page'));
const RPVPage = lazy(() => import('../pages/rpv/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/admin',
    element: (
      <ProtectedRoute allowedRoles={['admin']} requirePhoneVerification={true}>
        <AdminDashboard />
      </ProtectedRoute>
    )
  },
  {
    path: '/regional',
    element: (
      <ProtectedRoute allowedRoles={['coordinateur regional']}>
        <RegionalCoordinator />
      </ProtectedRoute>
    )
  },
  {
    path: '/prefectoral',
    element: (
      <ProtectedRoute allowedRoles={['coordinateur prefectoral']}>
        <PrefectoralCoordinator />
      </ProtectedRoute>
    )
  },
  {
    path: '/sous-prefectoral',
    element: (
      <ProtectedRoute allowedRoles={['coordinateur sous-prefectoral']}>
        <SousPrefectoralCoordinator />
      </ProtectedRoute>
    )
  },
  {
    path: '/rpv',
    element: (
      <ProtectedRoute allowedRoles={['relais paysans pour la victoire (VDP)']}>
        <RPVPage />
      </ProtectedRoute>
    )
  },
  {
    path: '/connexion',
    element: <Login/>
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
